'use strict';
var parent = require('../../stable/object/keys');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/actual/object/keys.js
// module id = 548
// module chunks = 13